import React from 'react';
import Dropzone from 'react-dropzone';
import EpubFolder from './EpubFolder';
import RejectedFilesAlert from './RejectedFilesAlert';
import EpubRezipperInfo from './EpubRezipperInfo';
import EpubZipper, { EPUB_FILE_INFO } from '../helpers/EpubZipper';
import {
  Button, ButtonGroup,
  Container, Row, Col,
  Label, Input, InputGroup, InputGroupText,
  Modal, ModalHeader, ModalBody, ModalFooter,
} from 'reactstrap';

export default class EpubRezipper extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      zipper: new EpubZipper(),
      name: null,
      rejected: [],
      count: 0,
      loading: false,
      key: 'files-0',
    };
  }

  onDrop = (files) => {
    const rej = this.state.rejected.slice();
    let count = this.state.count;
    files.map((file) => {
      if (this.state.zipper.includes(file.name)) {
        // do nothing
      } else if (this.state.zipper.addFile(file)) {
        this.checkForEpubName(file.name);
        count += 1;
      } else {
        rej.push(file);
      }
    });
    this.setState({
      rejected: rej,
      count,
    });
  }

  checkForEpubName = (fileName) => {
    if (this.state.name) { return false; }
    const matches = /^[^ ]+(?=-[0-9]+\.x?htm)/.exec(fileName);
    if (matches) {
      this.setState({ name: matches[0] });
    }
  }

  removeFile = (type, index) => {
    this.state.zipper.removeFile(type, index);
    this.setState({ count: this.state.count - 1 });
  }

  removeAll = () => {
    this.state.zipper.resetFiles();
    this.setState({ name: null, count: 0 });
  }

  zipFileName = () => {
    if (/.epub$/.test(this.state.name)) {
      return this.state.name;
    }
    return `${this.state.name}.epub`;
  }

  toggleLoading = () => {
    this.setState({ loading: !this.state.loading });
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevState.loading && this.state.loading) {
      this.state.zipper.toEpub(this.zipFileName()).then((zip) => {
        this.toggleLoading();
      });
    }
  }

  fileGroups = () => EPUB_FILE_INFO.map((typeInfo) => {
    const type = typeInfo[0];
    return (<EpubFolder
      key={`folder-${type}`}
      type={type}
      name={typeInfo[1]}
      files={this.state.zipper.files[type]}
      removeFile={this.removeFile}
    />);
  })

  handleTitleChange = (e) => {
    e.preventDefault();
    const val = e.target.value.length === 0 ? null : e.target.value;
    this.setState({ name: val });
  }

  canZip = () => !this.state.loading && this.state.count > 0 && this.state.name !== null

  render() {
    const zipEnabled = this.canZip();
    return (<Container className="epub-rezipper" key={this.state.key}>
      <Row>
        <Col md={6}>
          <Dropzone
            style={{}}
            ref="dropzone"
            className="uploader-dropzone"
            ref="dropzone"
            onDrop={this.onDrop}
            inputProps={{ name: 'uploader-input', id: 'uploader-input' }}
          >
            <p className="uploader-text">
              <i className="fa fa-upload" />
              <br />
              Attach your ePub content files here.
            </p>
          </Dropzone>
        </Col>
        <Col md={6}>
          <EpubRezipperInfo />
          <br />
          <InputGroup>
            <InputGroupText>
              ePub Name
            </InputGroupText>
            <Input onChange={this.handleTitleChange} value={this.state.name || ''} type="text" name="name" id="name" placeholder="scr-sample" />
          </InputGroup>
          <RejectedFilesAlert files={this.state.rejected} />
          <div className="upload-form-header">
            <h2>{this.state.count} Files</h2>
            <ButtonGroup>
              <Button
                color="warning"
                onClick={this.removeAll}
                title="Remove the ePub name and all files"
                disabled={this.state.loading}
              >
                Clear All
              </Button>
              <Button
                style={{ width: '150px' }}
                color={zipEnabled ? 'success' : 'secondary'}
                onClick={this.toggleLoading}
                disabled={!zipEnabled}
                title={zipEnabled ? 'zip contents' : 'add files and a name before zipping'}
              >
                {this.state.loading ?
                  <img src="/assets/loading.gif" style={{ height: '20px' }} /> :
                  'Zip and Download'}
              </Button>
            </ButtonGroup>
          </div>
          {this.fileGroups()}
        </Col>
      </Row>
    </Container>);
  }
}
